import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SECRET_KEY_QRISLY } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { SecretKeyQrislyResponse } from 'src/app/types/response/webhook-response.type';

@Component({
  standalone: false,
  selector: 'app-apk-webhook',
  templateUrl: './apk-webhook.component.html',
  styleUrl: './apk-webhook.component.scss'
})
export class ApkWebhookComponent implements OnInit {
  private message = inject(NzMessageService);
  private baseService = inject(BaseService);
  private destroyRef = inject(DestroyRef);

  isModalGenerateConfigVisible = signal<boolean>(false);
  isDownloadApkModalVisible = signal<boolean>(false);
  isActived = signal<boolean>(true);
  webhookUrl = signal<string>('');
  secretKeyData = signal<SecretKeyQrislyResponse | null>(null);

  ngOnInit(): void {
    this.getSecretKey();
  }

  getSecretKey() {
    this.baseService.getData(SECRET_KEY_QRISLY)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: { data: SecretKeyQrislyResponse }) => {
          this.secretKeyData.set(res.data);
          this.webhookUrl.set(res.data.webhook_url);
          this.isActived.set(res.data.status === 'active');
        },
        error: (error) => {
          this.isActived.set(false);
          if (error.error.meta.message !== 'Secret key not found') {
            this.message.error(error.error.meta.message || 'Failed to get secret key');
          }
        }
      });
  }

  handleRegenerate(openModalOnSuccess: boolean = false) {
    this.baseService.putData(SECRET_KEY_QRISLY, {})
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: { data: SecretKeyQrislyResponse }) => {
          this.secretKeyData.set(res.data);
          this.message.success('Secret key regenerated successfully');
          if (openModalOnSuccess) {
            this.isModalGenerateConfigVisible.set(true);
          }
        },
        error: (error) => {
          this.message.error(error.error.meta.message || 'Failed to regenerate secret key');
        }
      });
  }

  handleDeactivate() {
    this.baseService.putData(SECRET_KEY_QRISLY + '/deactive', {})
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.message.success('Secret key deactivated successfully');
          this.getSecretKey();
        },
        error: (error) => {
          this.message.error(error.error.meta.message || 'Failed to deactivate secret key');
        }
      });
  }

  openModal() {
    this.handleRegenerate(true);
  }

  downloadAPK() {
    this.isDownloadApkModalVisible.set(true);
  }

  copyToClipboard(text: string | undefined) {
    if (!text) return;
    navigator.clipboard.writeText(text);
    this.message.success('Webhook URL copied to clipboard');
  }
}
